<template>
  <div class="clearfix">
    <span
      v-if="i > x"
      class="category-line"
    >/</span>
    <span
      :class="(lang=='ch'? 'category-name category-nameA':'category-name')"
      @mousemove="mouseover"
      @mouseout="mouseout"
      @click="
          onChange(id);
        "
    >{{ name }}</span>
  </div>
</template>

<script>
import { unionFlag } from '@utils';
export default {
  props: {
    i:{
      type: Number,
      default: 0,
    },
    x:{
      type: Number,
      default: 0,
    },
    id:{
      type: Number,
      default: 0,
    },
    name:{
      type: String,
    },
    onChange: Function,
    lang:{
      type: String,
    },
  },
  data(){
    return {
      union: unionFlag(),
    };
  },
  methods: {
    mouseover(event) {
      // 触发mouseover获取到clientWidth 和 scrollWidth
      if (event.target.clientWidth < event.target.scrollWidth) {
        // clientWidth < scrollWidth 说明文本溢出隐藏了
        // let X = event.target.offsetLeft; // 当前hover元素的X轴
        // let Y = event.target.offsetTop; // 当前hover元素的Y轴
        let X = event.clientX; // 当前hover元素的X轴
        let Y = event.clientY; // 当前hover元素的Y轴
        // let scrollTop =
        //   document.body.scrollTop || document.documentElement.scrollTop; // 网页卷曲高度
        let oldDiv = document.getElementById('EC');
        if (oldDiv) {
          document.body.removeChild(oldDiv);
        }
        let div = document.createElement('div');
        div.innerText = event.target.innerText; // 所有文字
        div.setAttribute('id', 'EC');
        div.style.position = 'fixed';
        // div.style.top = Y - scrollTop + 35 + "px"; // 这里取到hover元素要定位的top
        // div.style.left = X + 60 + "px";
        div.style.top = Y + 20 + 'px'; // 这里取到hover元素要定位的top
        div.style.left = X + 20 + 'px';
        div.style.maxWidth = '350px';
        div.style.height = 'auto';
        div.style.lineHeight = '18px';
        div.style.background = 'rgba(0,0,0,.7)';
        div.style.color = 'rgba(255,255,255,1)';
        div.style.fontSize = '12px';
        div.style.padding = '5px 8px';
        div.style.zIndex = '9999';
        div.style.borderRadius = '2px';
        document.body.appendChild(div);
      }
    },
    mouseout() {
      let div = document.getElementById('EC');
      if (div) {
        document.body.removeChild(div);
      }
    },
  },
};
</script>

<style lang="less">
  .category-name{
    font-size: 14px;
    float:left;
    cursor: pointer;
    &:hover{
      color: #4679A3;
    }
  }
  .category-nameA{
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;;
  }
  .long .category-name{
    float: right;
  }
  .text4 .category-name{
    max-width: 60px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .text3 .category-name{
    max-width: 45px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .text2 .category-name{
    max-width: 30px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .category-line{
    margin: 0 4px;
    color: #B2B2B2
  }
  .clearfix {zoom:1;overflow: hidden; text-overflow: ellipsis;white-space: nowrap;}
  .clearfix:after {content: '\20'; display: block; clear: both;}
</style>